import {inject} from "vue";
import axios from "axios";

const themes = import.meta.glob('@/css/theme/**/*.scss', { eager: true, query: '?inline' });

class Theme {
    app;
    theme;
    themes = {};
    element;
    styles = {};

    constructor(app) {
        this.app = app;

        Object.keys(themes).forEach(key => {
            const parts = key.split('/');
            this.themes[parts[parts.length - 2]] = themes[key].default;
        });
    }


    getColor(color, level) {
        return getComputedStyle(document.documentElement)
            .getPropertyValue(`--theme-${color}${level ? '-' + level : ''}`);
    }

    removeVariables() {
        let el = document.querySelector('#theme-variables');
        if (!el) return;
        el.remove();
    }

    restoreVariables() {
        let el = document.querySelector('#theme-variables');
        if (!el || !el.textContent.includes('/*')) return;
        const content = el.textContent.slice(2, -2).trim();
        const newEl = document.createElement('style');
        newEl.id = 'theme-variables';
        newEl.textContent = content;
        el.remove();
        document.head.appendChild(newEl);
    }

    isDarkMode() {
        return !!document.head.getAttribute('theme').match(/dark/);
    }

    set(name) {
        return new Promise((resolve, reject) => {
            let el = document.querySelector('#theme-variables');
            if (el && !el.textContent.includes('/*')) {
                el.textContent = `/* ${el.textContent} */`;
            }

            Object.keys(this.themes).forEach((name) => {
                el = document.querySelector(`link[href*="/theme/${name}"]`);
                if (!el) return;
                el.remove();
            });

            el = document.querySelector('#theme-styles');
            if (el) el.remove();

            el = document.createElement('style');
            el.id = 'theme-styles';
            el.innerText = this.themes[name];
            document.head.appendChild(el);
            this.theme = name;
            resolve();
        });
    }

    setAndSave(theme) {
        return new Promise((resolve, reject) => {
            this.set(theme);
            this.app.config.globalProperties.$loader.setMode(theme.match(/dark/) ? 'dark' : 'light');
            axios.post(`/admin/main-server-settings/theme/${theme}`).then(() => {
                document.head.setAttribute('theme', theme);
                resolve();
            }).catch(reject);
        });
    }

    setCustomTheme(color, mode, variables) {
        return new Promise((resolve, reject) => {
            this.set(mode);
            this.app.config.globalProperties.$loader.setMode(mode);

            axios.post(`/admin/main-server-settings/theme/custom`, {
                custom_theme_mode: mode,
                custom_theme_color: color,
                custom_theme_variables: variables,
            }).then(resolve).catch(reject);
        });
    }
}

export default {
    install(app) {
        const theme = new Theme(app);
        if (import.meta.env.APP_ENV === 'local') {
            theme.set(document.head.getAttribute('theme'));
        }
        app.provide('theme', theme);
    }
}

export function useTheme() {
    return inject('theme');
}